define('SageDotCom/DataLayer/Events/personalisationOnLoad',[
    "SageDotCom/DataLayer/Events/eventBase"
],
function (EventBase) {
    function PersonalisationOnLoad(eventName, eventLabel, eventId, eventIdValue) {
        EventBase.call(this);

        this.props = {
            'event_action': eventName,
            'event_category': "component",
            'event_label': eventLabel,
            'event_nonint': 1,
            [eventId]: eventIdValue
        };
    }

    PersonalisationOnLoad.prototype = Object.create(EventBase.prototype);

    return PersonalisationOnLoad;
});
